<script>
import axios from 'axios';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewOptionDialog',
  mixins: [snackbarMixin, validatorMixin],
  props: {
    propertyCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      formData: {},
    };
  },
  mounted() {
    this.formData.propertyCode = this.propertyCode;

    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    submit() {
      axios.post('/descriptionOption', this.formData)
        .then((descriptionOptions) => {
          console.log(descriptionOptions);
          this.$emit('submit');
          this.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neue Option
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>
              <v-layout row wrap>

                <v-flex xs12 md8 py-0>
                  <v-text-field
                    v-model="formData.name"
                    label="Anzeigetext"
                    height="22"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md12 py-0>
                  <v-textarea
                    v-model="formData.text"
                    label="Langtext"
                    class="caption"
                  />
                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
